import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Color } from 'ng2-charts';
@Component({
  selector: 'app-discussion-trend',
  templateUrl: './discussion-trend.component.html',
  styleUrls: ['./discussion-trend.component.scss']
})
export class DiscussionTrend implements OnInit {

  @Input() dataReport: any
  title_report = 'Tổng Thảo Luận Và Xu Hướng Thảo Luận';
  dataFilterName = null;
  dataLastFilterName = null;
  htmlRight = '';
  public lineChart1Data = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'Like' },
    { data: [40, 69, 70, 21, 36, 55, 40], label: 'Share' }
  ];
  public lineChartLabels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

  public lineChart2Data = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'Tích cực' },
    { data: [40, 69, 70, 21, 36, 55, 40], label: 'Trung Tính' },
    { data: [40, 69, 70, 21, 36, 55, 40], label: 'Tiêu Cực' }
  ];

  public sentimentTimeChartOptions = {
    // scaleShowVerticalLines: true,
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      mode: 'index',
      intersect: false,
      position: 'nearest',
    },
    scales: {
      xAxes: [{
        stacked: true,
        scaleLabel: {
          stacked: true,
          display: false,
          labelString: 'Số lượng'
        }
      }],
      yAxes: [{
        id: 'A',
        scaleLabel: {
          display: true,
          labelString: 'Số lượng sắc thái bài viết',
        }
      }]
    },
    legend: {
      display: true,
      labels: {
        usePointStyle: true,
        fontSize: 11,
      }
    },
  };
  public likeShareTimeChartOptions = {
    // scaleShowVerticalLines: true,
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      mode: 'index',
      intersect: false,
      position: 'nearest',
    },
    scales: {
      xAxes: [{
        stacked: true,
        scaleLabel: {
          stacked: true,
          display: false,
          labelString: 'Số lượng lượt thích'
        }
      }],
      yAxes: [{
        id: 'A',
        scaleLabel: {
          display: true,
          labelString: 'Số lượng lượt thích và chia sẻ',
        }
      }]
    },
    legend: {
      display: true,
      labels: {
        usePointStyle: true,
        fontSize: 11,
      }
    },
  };

  public likeShareTimeChartColours: Array<any> = [
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#4e99af',
      borderWidth: 2,
      pointBackgroundColor: '#4e99af',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
      // pointHoverBackgroundColor: '#fff',
      // pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#ed956f',
      borderWidth: 2,
      pointBackgroundColor: '#ed956f',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
    },
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#2f7347',
      borderWidth: 2,
      pointBackgroundColor: '#2f7347',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
    },
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#8a6641',
      borderWidth: 2,
      pointBackgroundColor: '#8a6641',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
    },
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#0f6d7c',
      borderWidth: 2,
      pointBackgroundColor: '#0f6d7c',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
    },
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#f84e5d',
      borderWidth: 2,
      pointBackgroundColor: '#f84e5d',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
    },
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#0c3f51',
      borderWidth: 2,
      pointBackgroundColor: '#0c3f51',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
    },
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#4875b4',
      borderWidth: 2,
      pointBackgroundColor: '#4875b4',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
    }
  ];
  public sentimentTimeChartColours: Array<any> = [
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#4e99af',
      borderWidth: 2,
      pointBackgroundColor: '#4e99af',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
      // pointHoverBackgroundColor: '#fff',
      // pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#ed956f',
      borderWidth: 2,
      pointBackgroundColor: '#ed956f',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
    },
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#2f7347',
      borderWidth: 2,
      pointBackgroundColor: '#2f7347',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
    },
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#8a6641',
      borderWidth: 2,
      pointBackgroundColor: '#8a6641',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
    },
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#0f6d7c',
      borderWidth: 2,
      pointBackgroundColor: '#0f6d7c',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
    },
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#f84e5d',
      borderWidth: 2,
      pointBackgroundColor: '#f84e5d',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
    },
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#0c3f51',
      borderWidth: 2,
      pointBackgroundColor: '#0c3f51',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
    },
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#4875b4',
      borderWidth: 2,
      pointBackgroundColor: '#4875b4',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
    }
  ];
  public lineChartLegend = true;
  public lineChartType = 'line';
  public lineChartPlugins = [];


  public doughnutChartOptions: any = {
    plugins: {
      labels: {
        render: 'percentage',
        fontColor: 'black',
        position: 'outside',
        precision: 1,
        arc: true,
        fontSize: 12,
        textMargin: 4,
        fontStyle: 'bold'
      }
    }
  }
  public doughnutChartType = 'doughnut';
  public doughnutChartColors: Color[] = [
    { backgroundColor: ["#00b050", "#c00000" , "#bfbfbf"] }
  ];
  public doughnutChartLabels = ['Tích Cực', 'Tiêu Cực', 'Trung tính'];
  public doughnutChartData1 = [
    [30,40,60]
  ];
  public doughnutChartData2 = [
    [30,40,60]
  ];


  constructor() {

  }

  ngOnInit(): void {
  };
  ngOnChanges(changes: SimpleChanges) {
    if (this.dataReport && this.dataReport.data) {
      console.log(this.dataReport.data);
      this.mappingData()
     }
  }
  mappingData() {
    this.lineChartLabels = [];
    this.lineChart1Data = [
      { data: [], label: 'Like' },
      { data: [], label: 'Share' }
    ];

    this.lineChart2Data = [
      { data: [], label: 'Tích cực' },
      { data: [], label: 'Trung Tính' },
      { data: [], label: 'Tiêu Cực' }
    ];

    this.doughnutChartData1 = [
     
    ];
   this.doughnutChartData2 = [
     
    ];
  
    this.dataReport.data.dataFilter.byday.buckets.forEach(element => {
      this.lineChartLabels.push(element.key_as_string);

      this.lineChart1Data[0].data.push(element.likeCount.value);
      this.lineChart1Data[1].data.push(element.shareCount.value);

      this.lineChart2Data[0].data.push(element.posCount.statistic.statistic.doc_count);
      this.lineChart2Data[1].data.push(element.neuCount.statistic.statistic.doc_count);
      this.lineChart2Data[2].data.push(element.negCount.statistic.statistic.doc_count);

      this.doughnutChartData1 = [
        [
          this.dataReport.data.dataLastFilter.posCount.statistic.statistic.doc_count,
          this.dataReport.data.dataLastFilter.negCount.statistic.statistic.doc_count,
          this.dataReport.data.dataLastFilter.neuCount.statistic.statistic.doc_count
        ]
      ];
     this.doughnutChartData2 = [
        [
          this.dataReport.data.dataFilter.posCount.statistic.statistic.doc_count,
          this.dataReport.data.dataFilter.negCount.statistic.statistic.doc_count,
          this.dataReport.data.dataFilter.neuCount.statistic.statistic.doc_count
        ]
      ];
    
    });

    this.dataFilterName = this.dataReport.data.dataFilterName;
    this.dataLastFilterName = this.dataReport.data.dataLastFilterName;
    this.htmlRight = this.dataReport.data.htmlRight;
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/discussion-trend/discussion-trend.component.ts